var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"switch-toggle",class:{ disabled: _vm.disabled }},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', !_vm.value)}}}),_c('span',{staticClass:"slider"})])
}
var staticRenderFns = []

export { render, staticRenderFns }